import { render, staticRenderFns } from "./Radioprotection.vue?vue&type=template&id=5a09dc1c&"
import script from "./Radioprotection.vue?vue&type=script&lang=js&"
export * from "./Radioprotection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports